import React, { forwardRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import  PropTypes from 'prop-types';
import { useAuth } from '../../hooks/useAuth';



const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AskDialogDelete({onClose, selectedValue, open}) {
    const { authDataLang } = useAuth();
    const handleChange = (newValue) => {
        // console.log(newValue);
        onClose(newValue);
    };

    const handleClose = () => {
        onClose(selectedValue);
    };



  return (
    <div  >
      <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          sx={authDataLang?.view_sts ? {direction: 'ltr'} : {direction: 'rtl'}}
        >

        <DialogTitle sx={{fontFamily: 'b_mitra', fontSize: 24}} >حذف {selectedValue?.material?.name} از سبد خرید:</DialogTitle>
        <DialogContent >
          <DialogContentText id="alert-dialog-slide-description">
            <p style={{fontFamily: 'b_mitra', fontSize: 22}}>آیا می خواهید 
              (<span style={{
                  fontFamily: 'b_mitra', 
                  fontSize: 24, 
                  fontWeight: 'bold'
                }}>
                  <mark>{selectedValue?.material?.name}</mark>
                </span>
                ) از سبد خرید حذف شود؟
              </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button sx={{fontFamily: 'b_mitra', fontSize: 24}}
              onClick={handleChange}>
               <ins> انصراف</ins>
          </Button>
          <Button sx={{fontFamily: 'b_mitra', fontSize: 24}}
              onClick={() => handleChange(selectedValue)}
            >
              تایید
          </Button>

        </DialogActions>
      </Dialog>
    </div>
  );
}


AskDialogDelete.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};
